import * as React from 'react'
import { MuiTextFieldFormik } from '@user/components/Formik'
import { Field, getIn, useFormikContext } from 'formik'
import { EditActivityForm } from '../typings'

const maxLength = 30
const inputProps = { 'data-test-id': 'subject', maxLength: maxLength }

export function SubjectField() {
  const { values, errors, touched } = useFormikContext<EditActivityForm>()
  const error = getIn(errors, 'subject')
  const isTouched = getIn(touched, 'subject')
  const showError = !!(isTouched && error)

  const helperText = showError
    ? error
    : `${values.subject.length ?? 0}/${maxLength}`

  return (
    <Field
      required
      fullWidth
      size="small"
      name="subject"
      label="Subject"
      margin="normal"
      component={MuiTextFieldFormik}
      inputProps={inputProps}
      helperText={helperText}
      error={showError}
    />
  )
}
